var React = require('react');

function CategoryBike (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}")),React.createElement("title",{"key":1},"icon_bike"),React.createElement("g",{"id":"Layer_2","data-name":"Layer 2","key":2},[React.createElement("circle",{"className":"cls-1","cx":"19","cy":"36.5","r":"7","key":0}),React.createElement("circle",{"className":"cls-1","cx":"45","cy":"36.5","r":"7","key":1}),React.createElement("path",{"className":"cls-1","d":"M45,36.5l-5-16h3.39a1.93,1.93,0,0,1,1.61,3h0","key":2}),React.createElement("polyline",{"className":"cls-1","points":"32 36.5 19 36.5 26 24.5 41 24.5 32 36.5 24 20.5","key":3}),React.createElement("line",{"className":"cls-1","x1":"22","y1":"20.5","x2":"27","y2":"20.5","key":4})])]);
}

CategoryBike.defaultProps = {"viewBox":"0 0 64 64"};

module.exports = CategoryBike;

CategoryBike.default = CategoryBike;
